import {
  isOfflineAccessRefusal,
  type OfflineAccessRefusal,
  type OfflineAccessState,
} from "./state";

type Listener = (reason: OfflineAccessRefusal) => void;

const listeners = new Set<Listener>();

/**
 * Asks the presenter to show the reconnect sheet for `reason`. A valid lease
 * needs no sheet, and while Firebase is still restoring with no saved sign-in
 * (`auth_pending`) there is no known user's lease to judge, so neither shows it.
 */
export const showOfflineAccessPrompt = (
  reason: OfflineAccessState["reason"],
) => {
  if (!isOfflineAccessRefusal(reason)) return;
  listeners.forEach((listener) => listener(reason));
};

export const subscribeToOfflineAccessPrompt = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
